<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/connectUs"
          title="联系我们"
        />
      </div>
      <div style="display: flex; align-items: center">
        <div
          style="
            color: #555;
            font-weight: 700;
            font-size: 0.24rem;
            word-break: keep-all;
          "
        >
          联系方式
        </div>
        <el-row
          :gutter="16"
          type="flex"
          align="middle"
          style="width: 100%; margin-left: 1rem"
        >
          <el-col
            :span="12"
            style="
              font-size: 0.16rem;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              height: 3rem;
            "
          >
            <div>
              {{ connectMethods.companyName }}
            </div>
            <a
              style="
                text-decoration: none;
                color: #02a7f0a7;
                margin-top: -0.1rem;
              "
              target="_blank"
              :href="connectMethods.companyAddress"
              >{{ connectMethods.companyAddress }}</a
            >
            <div>电话：{{ connectMethods.tel }}</div>
            <div>邮箱：{{ connectMethods.email }}</div>
            <div>联系人：{{ connectMethods.person }}</div>
            <div>邮编：{{ connectMethods.postcode }}</div>
            <div>地址：{{ connectMethods.address }}</div>
            <div></div>
          </el-col>
          <el-col
            :span="12"
            style="height: 3rem"
            @mousewheel="wheelDetail"
            ref="myMap"
          >
            <!-- <img style="width:5.97rem;height:3.94rem" src="https://d1icd6shlvmxi6.cloudfront.net/gsc/HWHPSF/1f/d9/45/1fd9450986d643048083d90c034c0e7c/images/%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC/u10.png?pageId=b765a010-8feb-4498-b337-4aba71a24994" alt=""> -->
            <baidu-map class="bm-view" :center="currentLocation" :zoom="zoom">
              <bm-marker :position="currentLocation" :dragging="true">
                <bm-label
                  :content="connectMethods.companyName"
                  :offset="{ width: 0, height: 30 }"
                />
              </bm-marker>
              <!-- <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" /> -->
            </baidu-map>
          </el-col>
        </el-row>
      </div>
      <div style="display: flex; align-items: center">
        <div
          style="
            color: #555;
            font-weight: 700;
            font-size: 0.24rem;
            word-break: keep-all;
          "
        >
          产品咨询
        </div>
        <el-row
          :gutter="16"
          type="flex"
          align="middle"
          style="margin-top: 1rem; width: 100%; margin-left: 1rem"
        >
          <el-col :span="12" style="height: 4rem" id="tooltipBarId"></el-col>
          <el-col :span="12" style="height: 4rem; overflow: auto">
            <el-table border :data="tableData" v-loading="pageLoading">
              <el-table-column
                prop="place"
                label="地区"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                min-width="240"
                show-overflow-tooltip
                prop="personTel"
                label="联系方式"
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
export default {
  components: {
    TitleTips
  },
  name: 'connectUs',
  data() {
    return {
      routerList: [],
      zoom: 15,
      currentLocation: {},
      pageDataList: [
        // {
        //     name: "四川",
        //     value: 100,
        //     tipData: [
        //       {  personTel:"马站国 18682877865" },
        //       {  personTel:"马云 13482877865" },
        //       {  personTel:"马云34 13482877865" },
        //     ],
        //   },
        // {
        //     name: "浙江",
        //     value: 100,
        //     tipData: [
        //       {  personTel:"马站国 18682877865" },
        //       {  personTel:"马云 13482877865" },
        //       {  personTel:"马云34 13482877865" },
        //       {  personTel:"马云34 13482877865" },
        //     ],
        //   },
      ],
      tableData: [],
      connectMethods: {},
      pageLoading: false,
      indexInfoList: []
    };
  },
  created() {
    //   // 重新整合数据
    //   this.tableData=this.pageDataList.map((item)=>{
    //     let data=item.tipData.map((i)=>{
    //       return {
    //         name:item.name,
    //         personTel:i.personTel
    //       }
    //     })
    //     return data
    //   }).flat()
    // //  将每一行需要合并的行数，起始位置记录下来
    //   let dataList=this.tableData
    //   debugger
    //     // 获取每个类目下的条数
    //     let arr = []
    //     dataList.forEach(ele => {
    //       let firstIndex = dataList.findIndex(item => {
    //           return item.name === ele.name   // 当name相同的时候，返回第一个相同的Index 赋值给 firstIndex
    //         })
    //       if (arr.findIndex(item => {
    //         return item.firstIndex === firstIndex
    //       }) === -1) {
    //         arr.push({
    //           length: dataList.filter(item => {
    //             return item.name === ele.name    //利用数组的filter方法，过滤出相同lpn的数组的长度。数组长度-即为跨多少行
    //           }).length,
    //           firstIndex: firstIndex    // firstIndex 返回的是第一个name就满足的第一个Index,即为rowIndex开始于第几行。
    //         })
    //       }
    //     })
    //     // arr = new Set(arr)
    //     // console.log(arr)
    //     this.indexInfoList = arr
    //     debugger
  },

  methods: {
    getData() {
      this.pageLoading = true;
      http
        .post('/reception/contact/queryProductConsult', {})
        .then(res => {
          this.tableData = res.data;
          let placeArr = [];
          res.data.forEach(item => {
            if (placeArr.includes(item.place)) {
              this.pageDataList.forEach((i, index) => {
                if (i.name === item.place) {
                  this.pageDataList[index]['tipData'].push({
                    personTel: item.personTel
                  });
                }
              });
            } else {
              item.place.split('、').forEach(cItem => {
                let obj = {};

                obj['name'] = cItem;
                obj['value'] = 100;
                obj['tipData'] = [];
                obj['tipData'].push({
                  personTel: item.personTel
                });
                placeArr.push(item.place);
                this.pageDataList.push(obj);
              });
              // obj["name"] = item.place;
              // obj["value"] = 100;
              // obj["tipData"] = [];
              // obj["tipData"].push({
              //   personTel: item.personTel,
              // });
              // placeArr.push(item.place);
              // this.pageDataList.push(obj);
            }
          });

          // 重新整合数据
          // this.tableData=this.pageDataList.map((item)=>{
          //   let data=item.tipData.map((i)=>{
          //     return {
          //       name:item.name,
          //       personTel:i.personTel
          //     }
          //   })
          //   return data
          // }).flat()

          //  将每一行需要合并的行数，起始位置记录下来
          let dataList = this.tableData;
          // 获取每个类目下的条数
          let arr = [];
          dataList.forEach(ele => {
            let firstIndex = dataList.findIndex(item => {
              return item.name === ele.name; // 当lpn相同的时候，返回第一个相同的Index 赋值给 firstIndex
            });
            if (
              arr.findIndex(item => {
                return item.firstIndex === firstIndex;
              }) === -1
            ) {
              arr.push({
                length: dataList.filter(item => {
                  return item.name === ele.name; //利用数组的filter方法，过滤出相同lpn的数组的长度。数组长度-即为跨多少行
                }).length,
                firstIndex: firstIndex // firstIndex 返回的是第一个lpn就满足的第一个Index,即为rowIndex开始于第几行。
              });
            }
          });
          this.indexInfoList = arr;
          this.tooltipCharts();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    getConnectMethods() {
      http.post('/reception/homePage/getList', { groupType: 111 }).then(res => {
        // this.connectMethods=res.data
        let obj = {};
        res.data.forEach(item => {
          if (item.code === 'companyAddress') {
            obj['companyAddress'] = item.val;
          } else if (item.code === 'tel') {
            obj['tel'] = item.val;
          } else if (item.code === 'email') {
            obj['email'] = item.val;
          } else if (item.code === 'person') {
            obj['person'] = item.val;
          } else if (item.code === 'postcode') {
            obj['postcode'] = item.val;
          } else if (item.code === 'address') {
            obj['address'] = item.val;
          } else if (item.code === 'companyName') {
            obj['companyName'] = item.val;
            this.latitude(item.val);
          } else if (item.code === 'companyAddress') {
            obj['companyAddress'] = item.val;
          }
        });
        this.connectMethods = Object.assign({}, obj);
      });
    },
    latitude(address) {
      this.$jsonp('https://api.map.baidu.com/geocoding/v3/', {
        address: address, //地址
        output: 'json',
        ak: 'b25ZRy7yxfhW8bCL8QRDPPy9FPMbUKPM',
        city: '成都市',
        precise: 1
      }).then(res => {
        this.currentLocation = res.result.location;
        // 得到我们想要的内容
      });
    },
    // zoom(e){
    //   if
    // },
    tooltipCharts() {
      var myChart1 = this.$echarts.init(
        document.getElementById('tooltipBarId')
      );
      let that = this;
      var option = {
        grid: {
          show: true,
          left: '0',
          top: '0',
          right: '0',
          bottom: '5%'
          // backgroundColor: 'gray'
        },
        visualMap: {
          show: false,
          inRange: {
            color: ['#006edd', '#006edd'],
            symbolSize: [30, 100]
          }
        },
        tooltip: {
          padding: 8,
          enterable: true,
          transitionDuration: 1,
          textStyle: {
            color: '#fff',
            decoration: 'none'
          },

          formatter: function(params) {
            var color = params.color; //图例颜色
            var htmlStr = '<div>';
            htmlStr += params.name + '<br/>'; //x轴的名称
            if (
              params.data &&
              params.data.tipData &&
              params.data.tipData.length > 0
            ) {
              params.data.tipData.forEach(item => {
                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                htmlStr +=
                  '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
                  color +
                  ';"></span>';

                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                //htmlStr += '<span style="color:'+color+'">';

                //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
                htmlStr += params.seriesName + '：' + item.personTel + '<br/>';

                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                //htmlStr += '</span>';
              });
            }
            htmlStr += '</div>';
            return htmlStr;
          }
        },
        series: [
          {
            name: '销售经理',
            type: 'map',
            mapType: 'china',
            itemStyle: {
              normal: {
                // borderWidth: 2, //边框大小
                // borderColor: 'lightgreen',
                // areaStyle: { color: 'orange' },
                label: {
                  show: false
                }
              },
              emphasis: {
                label: {
                  show: true
                }
              }
            },
            label: {
              normal: {
                //静态的时候展示样式
                show: true, //是否显示地图省份得名称
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                }
              },
              emphasis: {
                //动态展示的样式
                color: '#fff'
              }
            },
            data: that.pageDataList || []
          }
        ]
      };
      myChart1.setOption(option);
    },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0) {
    //     let index = this.indexInfoList.findIndex(item => {
    //       //遍历数组
    //       return item.firstIndex === rowIndex;
    //     });
    //     if (index > -1) {
    //       return {
    //         rowspan: this.indexInfoList[index].length,
    //         colspan: 1
    //       };
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0
    //       };
    //     }
    //   }
    // },
    wheelDetail(e) {
      e.returnValue = false;
      if (e.deltaY > 0 && this.zoom > 0) {
        this.zoom--;
      } else if (e.deltaY < 0 && this.zoom < 20) {
        this.zoom++;
      } else {
        e.stopPropagation();
      }
    }
  },
  mounted() {
    this.getData();
    this.getConnectMethods();
    this.routerList = this.$route.matched;
    // debugger
    // this.$refs.myMap.addEventListener('mousewheel',this.wheelDetail)
  },

  watch: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .news-content {
      box-sizing: border-box;
      cursor: pointer;
      padding: 0.1rem;
      background: #f2f2f26f;
      width: 8.88rem;
      height: 100%;
      p:nth-child(1) {
        color: #333;
        font-size: 0.18rem;
        font-weight: 600;
      }
      p:nth-child(2) {
        margin: 0.05rem 0rem;
        color: #333;
        font-size: 0.14rem;
      }
      p:nth-child(3) {
        margin: 0.05rem 0rem;
        font-size: 0.13rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }
    .news-list {
      width: 100%;
      height: 0.49rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid #bfbfbf;
    }
  }
}
.bm-view {
  width: 100%;
  height: 300px;
}
</style>
